// import { lazy, Suspense, useEffect, useRef } from "react";
// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import { APP_ROUTES } from "./PageRoutes";
// import { Flex, Spin } from "antd";
// import Layouts from "../Components/Layouts";
// import { Redirect } from "react-router-dom/cjs/react-router-dom";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// const MedicalHistoryNew = lazy(() => import("../Components/Pages/Appoinments/MedicalHistoryNew"));
// const LeaderBoard = lazy(() => import("../Components/Pages/LeaderBoard"));
// const OrderHistory = lazy(() => import("../Components/Pages/OrderHistory"));
// const BookProcedure = lazy(() => import("../Components/Pages/Procedure/patientBookProcedure"));
// const Proceduralservice = lazy(() => import("../Components/Pages/ProceduralService/Proceduralservice"));
// const Invoice = lazy(() => import("../Components/Pages/Invoice"));
// const Dashboard = lazy(() => import("../Components/Pages/DashboardCurrent/DashboardCurrent"));
// const BookAppointment = lazy(() => import("../Components/Pages/DashboardCurrent/BookAppointment"));
// const Medicines = lazy(() => import("../Components/Pages/OrderMedicine"));
// const MedicineDetails = lazy(() => import("../Components/Pages/OrderMedicine/medicineDetails"));
// const Cart = lazy(() => import("../Components/Pages/Cart"));
// const LabTest = lazy(() => import("../Components/Pages/BookLabTest"));
// const TestDetails = lazy(() => import("../Components/Pages/BookLabTest/TestDetails"));
// const ProceduralServices = lazy(() => import("../Components/Pages/BookTest"));
// const PreConsult = lazy(() => import("../Components/Pages/Appoinments/PreConsult"));
// const VideoCall = lazy(() => import("../Components/Pages/Appoinments/VideoConsultation/PatientVideoCons"));
// const UserClinics = lazy(() => import("../Components/Pages/UserClinics"));
// const NewAnalytics = lazy(() => import("../Components/Pages/AnalyticsNew/NewAnalytics"));
// const EditEnrolledUser = lazy(() => import("../Components/Pages/EnrolledUsers/editEnrollUser"));
// const ServicePayment = lazy(() => import("../Components/Pages/PaymentInitiation/ServicePayment"));
// const PaymentInitiation = lazy(() => import("../Components/Pages/PaymentInitiation"));
// const OrderReport = lazy(() => import("../Components/Pages/OrderReports"));
// const Appointments = lazy(() => import("../Components/Pages/Appoinments"));
// const PatientList = lazy(() => import("../Components/Pages/PatientList"));
// const Payments = lazy(() => import("../Components/Pages/Payments"));
// const BillingReport = lazy(() => import("../Components/Pages/BillingReports"));
// const Accounts = lazy(() => import("../Components/Pages/Accounts"));
// const ChangePassword = lazy(() => import("../Components/Authentication/ChangePassword"));
// const UsersList = lazy(() => import("../Components/Pages/Users"));
// const ClinicsList = lazy(() => import("../Components/Pages/Clinics"));
// const AddUser = lazy(() => import("../Components/Pages/Users/AddUser"));
// const AddClinic = lazy(() => import("../Components/Pages/Clinics/AddClinic"));
// const AddNewAccount = lazy(() => import("../Components/Pages/Accounts/AddNewAccount"));
// const EnrolledUser = lazy(() => import("../Components/Pages/EnrolledUsers"));
// const Login = lazy(() => import("../Components/Authentication/Login"));
// const ForgotPassword = lazy(() => import("../Components/Authentication/ForgotPassword"));
// const AutoLogin = lazy(() => import("../Components/Authentication/AutoLogin"));
// const ProcedureList = lazy(() => import("../Components/Pages/Procedure"));
// const Notification = lazy(() => import("../Components/Pages/Notification/index"));
// const Referrals = lazy(() => import("../Components/Pages/Referral/index"));
// const Template = lazy(() => (import("../Components/Pages/SpecTemplates")));
// const SpecialityTemplateMap = lazy(() => (import("../Components/Pages/TempSpecMapping/index")));
// const UserTemplates = lazy(() => (import("../Components/Pages/UserTemplates")));
// const VirtualCash = lazy(() => (import("../Components/Pages/VirtualCash")));
// const Discount = lazy(() => (import("../Components/Pages/Discount")));
// const DevicesSetup = lazy(() => (import("../Components/Pages/RPM/DeviceSetup")));
// const TaskFrequency = lazy(() => (import("../Components/Pages/RPM/TaskFrequency")));
// const VitalParameters = lazy(() => (import("../Components/Pages/RPM/VitalParameter")));
// const RpmPatientPallette = lazy(() => (import("../Components/Pages/PatientList/PatientPallette")));
// const PatientCritical = lazy(() => (import("../Components/Pages/RPM/Criticality/Critical")));
// const PatientAbnormal = lazy(() => (import("../Components/Pages/RPM/Criticality/Abnormal")));
// const PatientNormal = lazy(() => (import("../Components/Pages/RPM/Criticality/Normal")));
// const RpmDashboard = lazy(() => (import("../Components/Pages/RPM/RpmDashboard")));
// const RpmClinicalNotes = lazy(() => (import("../Components/Pages/PatientList/PatientPallette/ClinicalNotes/addClinicalNote")));
// const RpmMedicalHistory = lazy(() => (import("../Components/Pages/PatientList/PatientPallette/MedicalHistory/viewAllHistory")));
// const RpmMedicalRecords = lazy(() => (import("../Components/Pages/PatientList/PatientPallette/MedicalRecords/viewAll")));
// const RpmActivityReport = lazy(() => (import("../Components/Pages/RPM/ActivityReportAll")));
// const PatientMedicalHistory = lazy(() => (import("../Components/Pages/PatientList/PatMedicalRecords/medicalHistory")));
// const PatientPrescriptions = lazy(() => (import("../Components/Pages/PatientList/PatMedicalRecords/prescriptions")));
// const PatientReports = lazy(() => (import("../Components/Pages/PatientList/PatMedicalRecords/reports")));
// const PatientVitals = lazy(() => (import("../Components/Pages/PatientList/PatMedicalRecords/vitals")));
// const EmergencyQR = lazy(() => (import("../Components/Pages/Appoinments/MedicalHistoryNew/EmergencyData")));
// const Membership = lazy(() => (import("../Components/Pages/Membership")));
// const NewMembership = lazy(() => (import("../Components/Pages/Membership/membershipPlans")));
// const FamilyMembers = lazy(() => (import("../Components/Pages/FamilyMembers")));
// const Consent = lazy(() => (import("../Components/Pages/Consent")));
// const PatientDevices = lazy(() => (import("../Components/Pages/PatientDevices")));

// const PageRouting = () => {
//   const idleTimerRef = useRef(null);
//   const history = useHistory();

//   const handleIdle = () => {
//      sessionStorage.clear();
//     sessionStorage.clear();
//     if ("caches" in window) {
//       caches.keys().then(names => {
//         for (let name of names) {
//           caches.delete(name);
//         }
//       });
//     }
//     window.location.href = APP_ROUTES.LOGIN;
//   };

//   useEffect(() => {
//     const resetTimer = () => {
//       if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
//       idleTimerRef.current = setTimeout(handleIdle, 7200000);
//     };
//     const events = ["mousemove", "keydown", "scroll", "click"];
//     events.forEach((event) => window.addEventListener(event, resetTimer));
//     resetTimer();
//     return () => {
//       events.forEach((event) => window.removeEventListener(event, resetTimer));
//       if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
//     };
//   }, []);

//   return (
//     <Router>
//       <Switch>
//         <Suspense fallback={<div className="flex items-center justify-center mt-[10%]">
//           <Flex align="center" gap="middle">
//             <Spin size="large" tip="Loading" />
//           </Flex>
//         </div>}>
//           <Route path={APP_ROUTES.FORGETPASSWORD} component={ForgotPassword} />
//           <Route exact path={APP_ROUTES.LOGIN} component={Login} />
//           <Route path={APP_ROUTES.AUTHENTICATE} component={AutoLogin} />
//           <div className={`${window.location.pathname === APP_ROUTES.LOGIN || window.location.pathname === APP_ROUTES.FORGETPASSWORD || window.location.pathname.includes('/authenticate') ? 'hidden' : ''}`}>
//             <Layouts>
//               <Suspense fallback={<div className="flex items-center justify-center mt-[10%]">
//                 <Flex align="center" gap="middle">
//                   <Spin size="large" tip="Loading" />
//                 </Flex>
//               </div>}>
//                 <Route path={APP_ROUTES.PAYMENTS} component={Payments} />
//                 <Route path={APP_ROUTES.ACCOUNTS} component={Accounts} />
//                 <Route path={APP_ROUTES.PATIENTLIST} component={PatientList} />
//                 <Route path={APP_ROUTES.APPOINMENTS} component={Appointments} />
//                 <Route path={APP_ROUTES.BILLINGREPORT} component={BillingReport} />
//                 <Route path={APP_ROUTES.CHANGEPASSWORD} component={ChangePassword} />
//                 <Route path={APP_ROUTES.USER} component={UsersList} />
//                 <Route path={APP_ROUTES.NEWUSER} component={AddUser} />
//                 <Route path={APP_ROUTES.CLINIC} component={ClinicsList} />
//                 <Route path={APP_ROUTES.NEWCLINIC} component={AddClinic} />
//                 <Route path={APP_ROUTES.NEWACCOUNT} component={AddNewAccount} />
//                 <Route path={APP_ROUTES.DASHBOARD} component={Dashboard} />
//                 <Route path={APP_ROUTES.PRECONSULTATION} component={PreConsult} />
//                 <Route path={APP_ROUTES.VIDEOCALL} component={VideoCall} />
//                 <Route path={APP_ROUTES.ENROLLEDUSER} component={EnrolledUser} />
//                 <Route path={APP_ROUTES.EDITENROLLUSER} component={EditEnrolledUser} />
//                 <Route path={APP_ROUTES.ORDERREPORT} component={OrderReport} />
//                 <Route path={APP_ROUTES.PHONEPEPAYMENT} component={PaymentInitiation} />
//                 <Route path={APP_ROUTES.NEWANALYTICS} component={NewAnalytics} />
//                 <Route path={APP_ROUTES.PROCEDURE} component={ProcedureList} />
//                 <Route path={APP_ROUTES.NOTIFICATION} component={Notification} />
//                 <Route path={APP_ROUTES.REFERRAL} component={Referrals} />
//                 <Route path={APP_ROUTES.TEMPLATES} component={Template} />
//                 <Route path={APP_ROUTES.SERVICEPAYMENT} component={ServicePayment} />
//                 <Route path={APP_ROUTES.SPECIALITYTEMPMAP} component={SpecialityTemplateMap} />
//                 <Route path={APP_ROUTES.USERCLINICS} component={UserClinics} />
//                 <Route path={APP_ROUTES.PROCEDURALSERVICE} component={Proceduralservice} />
//                 <Route path={APP_ROUTES.INVOICE} component={Invoice} />
//                 <Route path={APP_ROUTES.BOOKAPPOINTMENT} component={BookAppointment} />
//                 <Route path={APP_ROUTES.BOOKMEDICINES} component={Medicines} />
//                 <Route path={APP_ROUTES.MEDICINEDETAILS} component={MedicineDetails} />
//                 <Route path={APP_ROUTES.MYCART} component={Cart} />
//                 <Route path={APP_ROUTES.LABTEST} component={LabTest} />
//                 <Route path={APP_ROUTES.TESTDETAILS} component={TestDetails} />
//                 <Route path={APP_ROUTES.PROCEDURAL} component={ProceduralServices} />
//                 <Route path={APP_ROUTES.BOOKPROCEDURE} component={BookProcedure} />
//                 <Route path={APP_ROUTES.ORDERHISTORY} component={OrderHistory} />
//                 <Route path={APP_ROUTES.VIRTUALCASH} component={VirtualCash} />
//                 <Route path={APP_ROUTES.USERTEMPLATES} component={UserTemplates} />
//                 <Route path={APP_ROUTES.DISCOUNT} component={Discount} />
//                 <Route path={APP_ROUTES.DEVICESETUP} component={DevicesSetup} />
//                 <Route path={APP_ROUTES.RPMTASKFREQUENCY} component={TaskFrequency} />
//                 <Route path={APP_ROUTES.RPMVITALPARAMS} component={VitalParameters} />
//                 <Route path={APP_ROUTES.RPMPATIENTPALLETTE} component={RpmPatientPallette} />
//                 <Route path={APP_ROUTES.PATIENTCRITICAL} component={PatientCritical} />
//                 <Route path={APP_ROUTES.PATIENTABNORMAL} component={PatientAbnormal} />
//                 <Route path={APP_ROUTES.PATIENTNORMAL} component={PatientNormal} />
//                 <Route path={APP_ROUTES.RPMDASHBOARD} component={RpmDashboard} />
//                 <Route path={APP_ROUTES.RPMCLINICALNOTES} component={RpmClinicalNotes} />
//                 <Route path={APP_ROUTES.RPMMEDICALHISTORY} component={RpmMedicalHistory} />
//                 <Route path={APP_ROUTES.RPMMEDICALRECORDS} component={RpmMedicalRecords} />
//                 <Route path={APP_ROUTES.RPMACTIVITYREPORT} component={RpmActivityReport} />
//                 <Route path={APP_ROUTES.LEADERBOARD} component={LeaderBoard} />
//                 <Route path={APP_ROUTES.MEDICALHISTORY} component={PatientMedicalHistory} />
//                 <Route path={APP_ROUTES.PRESCRIPTIONS} component={PatientPrescriptions} />
//                 <Route path={APP_ROUTES.REPORTS} component={PatientReports} />
//                 <Route path={APP_ROUTES.VITALS} component={PatientVitals} />
//                 <Route path={APP_ROUTES.MEDICAL} component={MedicalHistoryNew} />
//                 <Route path={APP_ROUTES.EMERGENCYQR} component={EmergencyQR} />
//                 <Route path={APP_ROUTES.MEMBERSHIP} component={Membership} />
//                 <Route path={APP_ROUTES.NEWMEMBERSHIP} component={NewMembership} />
//                 <Route path={APP_ROUTES.FAMILYMEMBERS} component={FamilyMembers} />
//                 <Route path={APP_ROUTES.CONSENT} component={Consent} />
//                 <Route path={APP_ROUTES.PATIENTDEVICES} component={PatientDevices} />
//               </Suspense>
//             </Layouts>
//           </div>
//         </Suspense>
//         <Redirect from={`${process.env.PUBLIC_URL}/`} to={APP_ROUTES.LOGIN} />
//       </Switch>
//     </Router >
//   );
// };

// export { PageRouting };

/**
 * PageRouting/Index.jsx — FIXED & OPTIMIZED
 *
 * Bugs fixed in this version
 * ──────────────────────────────────────────────────────────────
 * 1. <Suspense> was a direct child of <Switch>.
 *    Switch only accepts <Route>/<Redirect> as children — anything
 *    else breaks route matching silently and causes blank renders.
 *    FIX: Single <Suspense> wraps the entire <Switch>, not individual
 *    route groups inside it.
 *
 * 2. <Redirect from="/" to={LOGIN}> caused an infinite redirect loop
 *    because APP_ROUTES.LOGIN is also "/".
 *    FIX: Redirect removed. Login is an exact route; unmatched paths
 *    fall through to a catch-all <Redirect to={DASHBOARD}> which
 *    ProtectedRoute handles — unauthenticated users get sent to LOGIN.
 *
 * 3. ProtectedRoute used the render-prop pattern, which creates a new
 *    function reference on every render and remounts the page component
 *    each time — the root cause of "component not rendering / too many
 *    reloads".
 *    FIX: ProtectedRoute renders <Route component={AuthGuard}> so
 *    React Router controls mounting cleanly with a stable reference.
 *
 * Security fixes (from audit)
 * ──────────────────────────────────────────────────────────────
 * FINDING 5: No auth check on any route → ProtectedRoute redirects
 *            unauthenticated users to LOGIN.
 * FINDING 8: No RBAC → allowedRoles prop enforced per route.
 *            ACCT_ADM / CLINIC_ADM hitting /enrolleduser →
 *            redirected to /unauthorized.
 *
 * Layout fix
 * ──────────────────────────────────────────────────────────────
 * <Layouts> (Header + SideMenu) is only mounted inside ProtectedRoute,
 * never on public pages. The old CSS-hidden <div> is gone entirely.
 *
 * RBAC summary
 * ──────────────────────────────────────────────────────────────
 *   SUPERADMIN_ONLY → /enrolleduser, /editenrolluser
 *   ALL_ROLES       → every other protected page
 *                     (SUPERADMIN | ACCT_ADM | CLINIC_ADM)
 */

import { lazy, Suspense, useEffect, useRef } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Flex, Spin } from "antd";
import { APP_ROUTES } from "./PageRoutes";
import Layouts from "../Components/Layouts";
import { NavigationProvider } from "../Context/NavigationContext";
// ─── Role constants ────────────────────────────────────────────────────────────
export const ROLES = {
  SUPERADMIN: "SUPERADMIN",
  ACCT_ADM:   "ACCT_ADM",
  CLINIC_ADM: "CLINIC_ADM",
};

const ALL_ROLES       = Object.values(ROLES);
const SUPERADMIN_ONLY = [ROLES.SUPERADMIN];

// ─── Lazy imports ──────────────────────────────────────────────────────────────
const Login               = lazy(() => import("../Components/Authentication/Login"));
const ForgotPassword      = lazy(() => import("../Components/Authentication/ForgotPassword"));
const AutoLogin           = lazy(() => import("../Components/Authentication/AutoLogin"));
const ChangePassword      = lazy(() => import("../Components/Authentication/ChangePassword"));
const Dashboard           = lazy(() => import("../Components/Pages/DashboardCurrent/DashboardCurrent"));
const PatientList         = lazy(() => import("../Components/Pages/PatientList"));
const Appointments        = lazy(() => import("../Components/Pages/Appoinments"));
const BillingReport       = lazy(() => import("../Components/Pages/BillingReports"));
const Payments            = lazy(() => import("../Components/Pages/Payments"));
const Accounts            = lazy(() => import("../Components/Pages/Accounts"));
const AddNewAccount       = lazy(() => import("../Components/Pages/Accounts/AddNewAccount"));
const UsersList           = lazy(() => import("../Components/Pages/Users"));
const AddUser             = lazy(() => import("../Components/Pages/Users/AddUserForm/index"));
const ClinicsList         = lazy(() => import("../Components/Pages/Clinics"));
const AddClinic           = lazy(() => import("../Components/Pages/Clinics/AddClinic"));
const EnrolledUser        = lazy(() => import("../Components/Pages/EnrolledUsers"));
const EditEnrolledUser    = lazy(() => import("../Components/Pages/EnrolledUsers/editEnrollUser"));
const OrderReport         = lazy(() => import("../Components/Pages/OrderReports"));
const PaymentInitiation   = lazy(() => import("../Components/Pages/PaymentInitiation"));
const ServicePayment      = lazy(() => import("../Components/Pages/PaymentInitiation/ServicePayment"));
const NewAnalytics        = lazy(() => import("../Components/Pages/AnalyticsLatest/NewAnalytics"));
const ProcedureList       = lazy(() => import("../Components/Pages/Procedure"));
const Notification        = lazy(() => import("../Components/Pages/Notification/index"));
const Referrals           = lazy(() => import("../Components/Pages/Referral/index"));
const Template            = lazy(() => import("../Components/Pages/SpecTemplates"));
const SpecialityTemplateMap = lazy(() => import("../Components/Pages/TempSpecMapping/index"));
const UserClinics         = lazy(() => import("../Components/Pages/UserClinics"));
const Proceduralservice   = lazy(() => import("../Components/Pages/ProceduralService/Proceduralservice"));
const Invoice             = lazy(() => import("../Components/Pages/Invoice"));
const BookAppointment     = lazy(() => import("../Components/Pages/DashboardCurrent/BookAppointment"));
const Medicines           = lazy(() => import("../Components/Pages/OrderMedicine"));
const MedicineDetails     = lazy(() => import("../Components/Pages/OrderMedicine/medicineDetails"));
const Cart                = lazy(() => import("../Components/Pages/Cart"));
const LabTest             = lazy(() => import("../Components/Pages/BookLabTest"));
const TestDetails         = lazy(() => import("../Components/Pages/BookLabTest/TestDetails"));
const ProceduralServices  = lazy(() => import("../Components/Pages/BookTest"));
const BookProcedure       = lazy(() => import("../Components/Pages/Procedure/patientBookProcedure"));
const OrderHistory        = lazy(() => import("../Components/Pages/OrderHistory"));
const VirtualCash         = lazy(() => import("../Components/Pages/VirtualCash"));
const UserTemplates       = lazy(() => import("../Components/Pages/UserTemplates"));
const Discount            = lazy(() => import("../Components/Pages/Discount"));
const DevicesSetup        = lazy(() => import("../Components/Pages/RPM/DeviceSetup"));
const TaskFrequency       = lazy(() => import("../Components/Pages/RPM/TaskFrequency"));
const VitalParameters     = lazy(() => import("../Components/Pages/RPM/VitalParameter"));
const RpmPatientPallette  = lazy(() => import("../Components/Pages/PatientList/PatientPallette"));
const PatientCritical     = lazy(() => import("../Components/Pages/RPM/Criticality/Critical"));
const PatientAbnormal     = lazy(() => import("../Components/Pages/RPM/Criticality/Abnormal"));
const PatientNormal       = lazy(() => import("../Components/Pages/RPM/Criticality/Normal"));
const RpmDashboard        = lazy(() => import("../Components/Pages/RPM/RpmDashboard"));
const RpmClinicalNotes    = lazy(() => import("../Components/Pages/PatientList/PatientPallette/ClinicalNotes/addClinicalNote"));
const RpmMedicalHistory   = lazy(() => import("../Components/Pages/PatientList/PatientPallette/MedicalHistory/viewAllHistory"));
const RpmMedicalRecords   = lazy(() => import("../Components/Pages/PatientList/PatientPallette/MedicalRecords/viewAll"));
const RpmActivityReport   = lazy(() => import("../Components/Pages/RPM/ActivityReportAll"));
const PatientMedicalHistory = lazy(() => import("../Components/Pages/PatientList/PatMedicalRecords/medicalHistory"));
const PatientPrescriptions  = lazy(() => import("../Components/Pages/PatientList/PatMedicalRecords/prescriptions"));
const PatientReports      = lazy(() => import("../Components/Pages/PatientList/PatMedicalRecords/reports"));
const PatientVitals       = lazy(() => import("../Components/Pages/PatientList/PatMedicalRecords/vitals"));
const MedicalHistoryNew   = lazy(() => import("../Components/Pages/Appoinments/MedicalHistoryNew"));
const EmergencyQR         = lazy(() => import("../Components/Pages/Appoinments/MedicalHistoryNew/EmergencyData"));
const Membership          = lazy(() => import("../Components/Pages/Membership"));
const NewMembership       = lazy(() => import("../Components/Pages/Membership/membershipPlans"));
const FamilyMembers       = lazy(() => import("../Components/Pages/FamilyMembers"));
const Consent             = lazy(() => import("../Components/Pages/Consent"));
const PatientDevices      = lazy(() => import("../Components/Pages/PatientDevices"));
const LeaderBoard         = lazy(() => import("../Components/Pages/LeaderBoard"));
const PreConsult          = lazy(() => import("../Components/Pages/Appoinments/PreConsult"));
const VideoCall           = lazy(() => import("../Components/Pages/Appoinments/VideoConsultation/PatientVideoCons"));
const DoctorEnrollmentForm = lazy(() => (import("../Components/Pages/UserRequestForm/doctorEnrollmentForm")));
const RPMEnrollmentForm = lazy(() => (import("../Components/Pages/UserRequestForm/RPMEnrollmentForm")));
const PatientDietPlans = lazy(() => import("../Components/Pages/PatientDietPlan"));
const DemoRequests = lazy(() => import("../Components/Pages/DemoRequests"));
const BillingPayments = lazy(() => import("../Components/Pages/BillingPayments/Index"));



// ─── Shared spinner ────────────────────────────────────────────────────────────
const PageSpinner = () => (
  <div className="flex items-center justify-center mt-[10%]">
    <Flex align="center" gap="middle">
      <Spin size="large" tip="Loading" />
    </Flex>
  </div>
);

// ─── Unauthorized page ─────────────────────────────────────────────────────────
const UnauthorizedPage = () => (
  <div className="flex flex-col items-center justify-center h-screen gap-4">
    <h1 className="text-2xl font-bold text-red-600">Access Denied</h1>
    <p className="text-gray-500">You do not have permission to view this page.</p>
    <a href={APP_ROUTES.DASHBOARD} className="text-blue-600 underline">
      Go to Dashboard
    </a>
  </div>
);

// ─── Auth helper ───────────────────────────────────────────────────────────────
const getLoggedUser = () => {
  try {
    const raw = sessionStorage.getItem("login_result");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// ─── ProtectedRoute ────────────────────────────────────────────────────────────
/**
 * KEY FIX: AuthGuard is defined as a named function outside the render
 * cycle of ProtectedRoute. This gives it a stable identity so React
 * Router never remounts the page component between renders.
 *
 * Passing an inline arrow function to <Route component={...}> would
 * create a new reference on every render, forcing a full unmount +
 * remount of the page — which was causing the "too many reloads" issue.
 */
const makeAuthGuard = (Page, allowedRoles) => {
  const AuthGuard = (props) => {
    const loggedUser = getLoggedUser();

    // FINDING 5 fix — redirect to login if no session
    if (!loggedUser) {
      return (
        <Redirect
          to={{ pathname: APP_ROUTES.LOGIN, state: { from: props.location } }}
        />
      );
    }

    // FINDING 8 fix — redirect if role not permitted
    if (allowedRoles && allowedRoles.length > 0) {
      const userRole = loggedUser?.user?.rolecode?.toUpperCase();
      if (!allowedRoles.includes(userRole)) {
        return <Redirect to="/unauthorized" />;
      }
    }

    // Auth + role OK — render page inside Layout
    // <Layouts> only mounts here, never on public pages
    return (
      <Layouts>
        <Page {...props} />
      </Layouts>
    );
  };

  // Name it for React DevTools
  AuthGuard.displayName = `AuthGuard(${Page.displayName || Page.name || "Component"})`;
  return AuthGuard;
};

// const ProtectedRoute = ({ component: Page, allowedRoles, ...routeProps }) => {
//   // useMemo equivalent — guard is created once per unique Page+roles combo
//   const Guard = makeAuthGuard(Page, allowedRoles);
//   return <Route {...routeProps} component={Guard} />;
// };

// 2nd version
// const ProtectedRoute = ({ component: Page, allowedRoles, ...routeProps }) => {
//   // useRef holds the Guard across renders — same reference forever
//   const guardRef = useRef(null);

//   if (!guardRef.current) {
//     // Created ONCE on first render, never again
//     guardRef.current = makeAuthGuard(Page, allowedRoles);
//   }

//   return <Route {...routeProps} component={guardRef.current} />;
// };

// 3rd version
const ProtectedRoute = ({ component: Page, allowedRoles, ...routeProps }) => {
  const guardRef = useRef(null);
  const pageRef = useRef(Page); // track if Page itself changed

  if (!guardRef.current || pageRef.current !== Page) {
    pageRef.current = Page;
    guardRef.current = makeAuthGuard(Page, allowedRoles);
  }

  return <Route {...routeProps} component={guardRef.current} />;
};

// ─── Idle-logout hook ──────────────────────────────────────────────────────────
const IDLE_TIMEOUT_MS = 2 * 60 * 60 * 1000; // 2 hours

const useIdleLogout = () => {
  const timerRef = useRef(null);

  useEffect(() => {
    const logout = () => {
       sessionStorage.clear();
      sessionStorage.clear();
      if ("caches" in window) {
        caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
      }
      window.location.href = APP_ROUTES.LOGIN;
    };

    const reset = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(logout, IDLE_TIMEOUT_MS);
    };

    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((e) => window.addEventListener(e, reset));
    reset(); // start timer immediately

    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      clearTimeout(timerRef.current);
    };
  }, []);
};

// ─── PageRouting ───────────────────────────────────────────────────────────────
const PageRouting = () => {
  useIdleLogout();

  /**
   * <Suspense> wraps the entire <Switch> — NOT individual groups inside it.
   * <Switch> only processes <Route> and <Redirect> as direct children.
   * Any other element (Suspense, div, Fragment) placed inside Switch as a
   * direct child breaks route matching and causes blank / looping renders.
   */
  return (
    <NavigationProvider>
      <Suspense fallback={<PageSpinner />}>
        <Switch>

          {/* ── Public routes — no auth, no Layout ───────────────────────── */}
          <Route exact path={APP_ROUTES.LOGIN}          component={Login} />
          <Route       path={APP_ROUTES.FORGETPASSWORD} component={ForgotPassword} />
          <Route       path={APP_ROUTES.AUTHENTICATE}   component={AutoLogin} />
          <Route       path={APP_ROUTES.DOCTORENROLLMENTFORM}   component={DoctorEnrollmentForm} />
          <Route       path={APP_ROUTES.RPMENROLLMENTFORM}   component={RPMEnrollmentForm} />
          <Route       path="/unauthorized"             component={UnauthorizedPage} />

          {/* ── SUPERADMIN only ──────────────────────────────────────────── */}
          <ProtectedRoute path={APP_ROUTES.ENROLLEDUSER}   component={EnrolledUser}     allowedRoles={SUPERADMIN_ONLY} />
          <ProtectedRoute path={APP_ROUTES.EDITENROLLUSER} component={EditEnrolledUser} allowedRoles={SUPERADMIN_ONLY} />

          {/* ── All roles: SUPERADMIN | ACCT_ADM | CLINIC_ADM ────────────── */}
          <ProtectedRoute path={APP_ROUTES.DASHBOARD}          component={Dashboard}             allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PATIENTLIST}        component={PatientList}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.APPOINMENTS}        component={Appointments}          allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.BILLINGREPORT}      component={BillingReport}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PAYMENTS}           component={Payments}              allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.ACCOUNTS}           component={Accounts}              allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.NEWACCOUNT}         component={AddNewAccount}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.ORDERREPORT}        component={OrderReport}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.CHANGEPASSWORD}     component={ChangePassword}        allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.USER}               component={UsersList}             allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.NEWUSER}            component={AddUser}               allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.CLINIC}             component={ClinicsList}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.NEWCLINIC}          component={AddClinic}             allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PRECONSULTATION}    component={PreConsult}            allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.VIDEOCALL}          component={VideoCall}             allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PHONEPEPAYMENT}     component={PaymentInitiation}     allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.SERVICEPAYMENT}     component={ServicePayment}        allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.NEWANALYTICS}       component={NewAnalytics}          allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PROCEDURE}          component={ProcedureList}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.NOTIFICATION}       component={Notification}          allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.REFERRAL}           component={Referrals}             allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.TEMPLATES}          component={Template}              allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.SPECIALITYTEMPMAP}  component={SpecialityTemplateMap} allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.USERCLINICS}        component={UserClinics}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PROCEDURALSERVICE}  component={Proceduralservice}     allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.INVOICE}            component={Invoice}               allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.BOOKAPPOINTMENT}    component={BookAppointment}       allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.BOOKMEDICINES}      component={Medicines}             allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.MEDICINEDETAILS}    component={MedicineDetails}       allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.MYCART}             component={Cart}                  allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.LABTEST}            component={LabTest}               allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.TESTDETAILS}        component={TestDetails}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PROCEDURAL}         component={ProceduralServices}    allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.BOOKPROCEDURE}      component={BookProcedure}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.ORDERHISTORY}       component={OrderHistory}          allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.VIRTUALCASH}        component={VirtualCash}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.USERTEMPLATES}      component={UserTemplates}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.DISCOUNT}           component={Discount}              allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.DEVICESETUP}        component={DevicesSetup}          allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMTASKFREQUENCY}   component={TaskFrequency}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMVITALPARAMS}     component={VitalParameters}       allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMPATIENTPALLETTE} component={RpmPatientPallette}    allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PATIENTCRITICAL}    component={PatientCritical}       allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PATIENTABNORMAL}    component={PatientAbnormal}       allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PATIENTNORMAL}      component={PatientNormal}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMDASHBOARD}       component={RpmDashboard}          allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMCLINICALNOTES}   component={RpmClinicalNotes}      allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMMEDICALHISTORY}  component={RpmMedicalHistory}     allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMMEDICALRECORDS}  component={RpmMedicalRecords}     allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.RPMACTIVITYREPORT}  component={RpmActivityReport}     allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.LEADERBOARD}        component={LeaderBoard}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.MEDICALHISTORY}     component={PatientMedicalHistory} allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PRESCRIPTIONS}      component={PatientPrescriptions}  allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.REPORTS}            component={PatientReports}        allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.VITALS}             component={PatientVitals}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.MEDICAL}            component={MedicalHistoryNew}     allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.EMERGENCYQR}        component={EmergencyQR}           allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.MEMBERSHIP}         component={Membership}            allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.NEWMEMBERSHIP}      component={NewMembership}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.FAMILYMEMBERS}      component={FamilyMembers}         allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.CONSENT}            component={Consent}               allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.PATIENTDEVICES}     component={PatientDevices}        allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.DIETPLAN}           component={PatientDietPlans}      allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.DEMOREQUESTS}       component={DemoRequests}          allowedRoles={ALL_ROLES} />
          <ProtectedRoute path={APP_ROUTES.BILLINGPAYMENTS}    component={BillingPayments}      allowedRoles={ALL_ROLES} />
          {/* ── Catch-all: unknown paths go to dashboard ─────────────────── */}
          {/* ProtectedRoute on /dashboard redirects to LOGIN if not authed  */}
          <Redirect to={APP_ROUTES.DASHBOARD} />

        </Switch>
      </Suspense>
    </NavigationProvider>
  );
};

export { PageRouting };
